import React from 'react';

interface LogoIconProps {
  size?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const LogoIcon: React.FC<LogoIconProps> = ({
  size = 32,
  color = 'currentColor',
  className,
  style,
}) => (
  <svg
    viewBox="60 60 170 185"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    aria-hidden="true"
  >
    <path
      fill={color}
      d="M200.19,130.99c-.65,22.79,1.3,31.03-11.85,51.35-.41-1.48-1.08-4-1.11-5.29l-.72-31.82-31.67,31.37,19.81,19.55c-9.23,8.25-18.48,15.15-29.79,19.3-8.85-2.75-17-7.66-24.6-13.02l.22-58.73,26.45,25.25,72.96-72.91c.26-3.66.22-6.67-.14-10.55l-74.88-17.04-77.1,16.75.2,61.72c.06,19.86,7.48,37.59,20.46,52.39,15.62,16.74,34.63,29.26,56.11,37.4,19.32-7.38,35.76-17.64,50.4-31.55,15.31-14.55,24.79-33.74,25.16-55.19.23-12.92.23-24.73-.43-37.64l-19.48,18.65ZM100.93,182.34c-8.56-12.23-12.89-25.68-12.89-40.38v-42.31c64.39-11.09,40.12-16.79,104.22,0l-41.89,41.04-33.26-33.01-16.32.76.15,73.91Z"
    />
  </svg>
);

export default LogoIcon;
